import classNames from "classnames";
import Button from "Components/button";
import { hasEmptyRequiredFields, TextAreaWidget, TextWidget } from "Components/optionForm";
import React, { useCallback } from "react";
import { useResizeDetector } from "react-resize-detector";
import { requiredFields } from "../constants";
import locale from "./workSpaceEditor.locale";
export default function WorkSpaceEditor(props) {
    var _a, _b;
    const { ref: observableRef } = useResizeDetector();
    const handleChangeDraft = useCallback((value, fieldName) => {
        fieldName &&
            props.onSetDraft &&
            props.onSetDraft({
                [fieldName]: value
            });
    }, [props.onSetDraft]);
    const isEmptyRequiredFields = hasEmptyRequiredFields(props.draft, requiredFields);
    const handleCancel = useCallback(() => {
        props.onSetDraft && props.onSetDraft({});
    }, [props.onSetDraft]);
    const handleSave = useCallback(() => {
        props.draft && props.onSaveWorkSpace && props.onSaveWorkSpace(props.draft);
    }, [props.onSaveWorkSpace, props.draft]);
    return (React.createElement("div", { className: classNames("flex-single-column with-gap-24", props.className) },
        React.createElement(TextWidget, { value: ((_a = props.draft) === null || _a === void 0 ? void 0 : _a.Name) || "", fieldName: "Name", onChange: handleChangeDraft, label: locale.NAME, labelMode: "floating", height: 45 }),
        React.createElement("div", { className: "flex-greedy-block flex-shrink overflow-hidden", ref: observableRef },
            React.createElement(TextAreaWidget, { value: ((_b = props.draft) === null || _b === void 0 ? void 0 : _b.Description) || "", minHeight: "calc(100% - 8px)", maxHeight: "calc(100% - 8px)", height: "calc(100% - 8px)", labelMode: "floating", autoResizeEnabled: false, fieldName: "Description", onChange: handleChangeDraft, label: locale.DESCRIPTION })),
        React.createElement("div", { className: "d-flex justify-content-flex-end with-gap-8" },
            React.createElement(Button, { className: "btn-h-m p-8-24", text: locale.CANCEL, onClick: handleCancel, disabled: !props.hasChanges }),
            React.createElement(Button, { text: locale.SAVE, className: "btn-primary btn-h-m p-8-24", disabled: isEmptyRequiredFields || !props.hasChanges, onClick: handleSave }))));
}
